import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { logout } from 'modules/auth/actions';
import selfServicesApi from 'modules/selfServices/service';
import PaymentStatus, { fromFinalInvoice } from './types/PaymentStatus';
import onlinePaymentApi from './service';
import { OnlinePaymentState } from './types/OnlinePaymentState';

const INITIAL_STATE: OnlinePaymentState = {
  isPayingModalOpen: false,
  status: PaymentStatus.WAITING_FOR_USER,
  isPendingDismissed: false,
};

const updateStatusUnlessDismissed = (state: OnlinePaymentState, status: PaymentStatus): OnlinePaymentState => {
  if (state.isPendingDismissed && status === PaymentStatus.PENDING) {
    return state;
  }

  return {
    ...state,
    status,
    isPendingDismissed: false,
  };
};

const onlinePaymentSlice = createSlice({
  name: 'onlinePayment',
  initialState: INITIAL_STATE,
  reducers: {
    openPayingModal: (state) => ({
      ...state,
      isPayingModalOpen: true,
    }),
    closePayingModal: (state) => ({
      ...state,
      isPayingModalOpen: false,
      status: state.status === PaymentStatus.PENDING ? PaymentStatus.WAITING_FOR_USER : state.status,
      isPendingDismissed: state.isPendingDismissed || state.status === PaymentStatus.PENDING,
    }),
    setPaymentStatus: (state, action: PayloadAction<PaymentStatus>) => ({
      ...state,
      status: action.payload,
      isPendingDismissed: false,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => INITIAL_STATE);

    builder
      .addMatcher(selfServicesApi.endpoints.getSelfServiceById.matchFulfilled, (state, { payload }) => (
        updateStatusUnlessDismissed(state, payload.finalInvoice ? fromFinalInvoice(payload.finalInvoice) : PaymentStatus.WAITING_FOR_USER)
      ));

    builder
      .addMatcher(onlinePaymentApi.endpoints.getFinalInvoiceStatus.matchFulfilled, (state, { payload }) => (
        updateStatusUnlessDismissed(state, fromFinalInvoice(payload))
      ));
  },
});

export default onlinePaymentSlice;
